/**
 * The Finvari bird mark, shown in the app bar and on the sign-in screen.
 *
 * Referenced by URL out of `public/` rather than imported as a module so the
 * browser fetches and caches one file for every place it appears — including
 * the browser tab, which `index.html` points at this same asset.
 */
import { Box } from '@mui/material';

const BIRD_LOGO_SRC = '/bird-logo.svg';

export function BirdLogo({ size }: { size: number }) {
    return (
        <Box
            component="img"
            src={BIRD_LOGO_SRC}
            alt="Finvari"
            sx={{ width: size, height: size, display: 'block' }}
        />
    );
}
